import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_score",
  "use": "sort_score-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_score\"><path d=\"M9 2a7 7 0 0 1 5.29 11.584l3.564 3.562a.5.5 0 1 1-.708.708l-3.562-3.563A7 7 0 1 1 9 2Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 9 3Z\" /><path d=\"M10 11h1V9h-1zm.5 2 2.5-2H8zM7 7h1v2H7zm.5-2L10 7H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol